import { useBubbleGetCandidateStats } from "@crowdcoursing/api/openapi";
import { DateTime } from "luxon";
import { useMemo } from "react";

import { getTotalCandidateCountFromStats } from "~ui/utils/getTotalCandidateCountFromStats";

/**
 * Total candidates in a bubble scope, using the same candidate stats query as the Candidacy tab.
 */
export const useTotalCandidateCountForBubble = (bubbleId?: string): number | null => {
  const dateParams = useMemo(
    () => ({
      endDate: DateTime.now().toISO(),
      isAggregate: true,
      startDate: DateTime.now().minus({ months: 1 }).toISO(),
    }),
    [],
  );

  const { data } = useBubbleGetCandidateStats(
    {
      pathParams: { bubbleId: bubbleId ?? "" },
      queryParams: dateParams,
    },
    {
      enabled: !!bubbleId && bubbleId !== "",
      staleTime: 30000,
    },
  );

  return useMemo(() => getTotalCandidateCountFromStats(data?.stats), [data?.stats]);
};
